<template>
  <div id="myModal" class="modal fade in" role="dialog" style="display: block;">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" @click="$emit('close')">&times;</button>
          <h4 class="modal-title">{{ title }}</h4>
        </div>
        <div class="modal-body">
          <slot name="content"/>
        </div>
        <div class="modal-footer">
          <slot name="footer"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MaiModal',
  props: {
    title: {
      type: String
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/MaiModal.vue